import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Bookings\VirtualCardController::reveal
* @see app/Http/Controllers/Admin/Bookings/VirtualCardController.php:16
* @route '/bookings/{booking}/virtual-card/reveal'
*/
export const reveal = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reveal.url(args, options),
    method: 'post',
})

reveal.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/virtual-card/reveal',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\VirtualCardController::reveal
* @see app/Http/Controllers/Admin/Bookings/VirtualCardController.php:16
* @route '/bookings/{booking}/virtual-card/reveal'
*/
reveal.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return reveal.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\VirtualCardController::reveal
* @see app/Http/Controllers/Admin/Bookings/VirtualCardController.php:16
* @route '/bookings/{booking}/virtual-card/reveal'
*/
reveal.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reveal.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\VirtualCardController::reveal
* @see app/Http/Controllers/Admin/Bookings/VirtualCardController.php:16
* @route '/bookings/{booking}/virtual-card/reveal'
*/
const revealForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reveal.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\VirtualCardController::reveal
* @see app/Http/Controllers/Admin/Bookings/VirtualCardController.php:16
* @route '/bookings/{booking}/virtual-card/reveal'
*/
revealForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reveal.url(args, options),
    method: 'post',
})

reveal.form = revealForm

/**
* @see \App\Http\Controllers\Admin\Bookings\VirtualCardController::claim
* @see app/Http/Controllers/Admin/Bookings/VirtualCardController.php:26
* @route '/bookings/{booking}/virtual-card/claim'
*/
export const claim = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: claim.url(args, options),
    method: 'post',
})

claim.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/virtual-card/claim',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\VirtualCardController::claim
* @see app/Http/Controllers/Admin/Bookings/VirtualCardController.php:26
* @route '/bookings/{booking}/virtual-card/claim'
*/
claim.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return claim.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\VirtualCardController::claim
* @see app/Http/Controllers/Admin/Bookings/VirtualCardController.php:26
* @route '/bookings/{booking}/virtual-card/claim'
*/
claim.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: claim.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\VirtualCardController::claim
* @see app/Http/Controllers/Admin/Bookings/VirtualCardController.php:26
* @route '/bookings/{booking}/virtual-card/claim'
*/
const claimForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: claim.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\VirtualCardController::claim
* @see app/Http/Controllers/Admin/Bookings/VirtualCardController.php:26
* @route '/bookings/{booking}/virtual-card/claim'
*/
claimForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: claim.url(args, options),
    method: 'post',
})

claim.form = claimForm

const virtualCard = {
    reveal: Object.assign(reveal, reveal),
    claim: Object.assign(claim, claim),
}

export default virtualCard